import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'towerAd',
    initialState: {
        hideTowerAd: false,
    },
}).extend({
    selectors: () => ({
        getHideTowerAd: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideTowerAd),
    }),
});
